import { Modal, Row, Col, Card, Button, Form } from "antd";
import React, { useState, useEffect } from "react";
import Format from "utils/format/Format";
import LabelValue from "components/foundation/input/LabelValue";
import type { FormInstance } from "antd";

interface Plan {
  id: string | number;
  name: string;
  price: number;
  code: string;
}

interface PlanSelectModalProps {
  plans: Plan[];
  form: FormInstance;
  detailDK?: any;
}

const PlanSelectModal: React.FC<PlanSelectModalProps> = ({
  plans,
  form,
  detailDK,
}) => {
  const selectedPlanId = Form.useWatch("plan_id", form);
  const isRetry = detailDK?.is_retry === true && detailDK?.is_public !== true;
  const hasLockedPlan = !isRetry && Boolean(detailDK?.plan_name?.trim());

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOk = (plan: Plan) => {
    form.setFieldsValue({ plan_id: plan.id });
    setIsModalOpen(false);
  };

  return (
    <div>
      <Form.Item
        label="Gói cước"
        name="plan_id"
        labelCol={{ span: 10 }}
        wrapperCol={{ span: 14 }}
        colon={false}
        rules={[{ required: true, message: "Vui lòng chọn gói cước" }]}
      >
        <>
          <Button
            style={{ width: "100%", textAlign: "left" }}
            onClick={() => setIsModalOpen(true)}
            disabled={hasLockedPlan}
            // disabled={Boolean(
            //   detailDK?.plan_name && detailDK.plan_name.trim() !== "",
            // )}
          >
            {/* {detailDK?.plan_name && detailDK.plan_name.trim() !== ""
              ? detailDK.plan_name
              : selectedPlanId
                ? plans.find((p) => p.id === selectedPlanId)?.name
                : "Chọn gói cước"} */}
              {hasLockedPlan
                ? detailDK.plan_name
                : selectedPlanId
                  ? plans.find((p) => String(p.id) === String(selectedPlanId))?.name
                  : "Chọn gói cước"}
          </Button>

          <Modal
            title="Chọn gói cước"
            open={isModalOpen}
            onCancel={() => setIsModalOpen(false)}
            footer={null}
            width={800}
          >
            <div
              style={{
                maxHeight: "500px",
                overflowY: "auto",
                paddingRight: "4px",
              }}
            >
              <Row gutter={[8, 8]} className="dkttb">
                {plans.map((plan) => (
                  <Col xs={12} sm={12} md={8} lg={8} xl={8} key={plan.id}>
                    <Card
                      onClick={() => handleOk(plan)}
                      title={plan.name}
                      className={`cursor-pointer transition rounded-lg !px-3 !py-2
                    ${
                      form.getFieldValue("plan_id") === plan.id
                        ? "border-2"
                        : "border border-gray-200"
                    }`}
                      style={{
                        borderColor:
                          form.getFieldValue("plan_id") === plan.id
                            ? "var(--mk-p-color)"
                            : "",
                      }}
                    >
                      <LabelValue
                        label="Tên gói"
                        value={plan.name}
                        sm={8}
                        bold="false"
                        textSize={13}
                        textAlign="right"
                        mb={0}
                      />
                      <LabelValue
                        label="Mã gói"
                        value={plan.code}
                        sm={8}
                        bold="false"
                        textSize={13}
                        textAlign="right"
                        mb={0}
                      />
                      <LabelValue
                        label="Giá"
                        value={Format.DPrice(plan.price)}
                        sm={8}
                        bold="false"
                        textSize={13}
                        textAlign="right"
                        mb={0}
                      />
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          </Modal>
        </>
      </Form.Item>
    </div>
  );
};

export default PlanSelectModal;
